import React from 'react';
import { useTranslation } from 'react-i18next';
import SearchableSelect from '../SearchableSelect/SearchableSelect';
import { ISizeItem } from '../../../modules/API/Products/models/size';
import RulerIcon from '../../icons/IconLib/RulerIcon';

interface Props {
    sizes: ISizeItem[];
    value: ISizeItem | null;
    onSelect: (size: ISizeItem | null) => void;
    placeholder?: string;
    disabled?: boolean;
    readOnly?: boolean;
    className?: string;
}

const SizeSelector: React.FC<Props> = ({
    sizes,
    value,
    onSelect,
    placeholder,
    disabled,
    readOnly,
    className,
}) => {
    const [t] = useTranslation('selectors');

    return (
        <SearchableSelect<ISizeItem>
            items={sizes}
            value={value}
            onSelect={onSelect}
            getKey={(s) => s.Code}
            getLabel={(s) => (s.Description ?? '').trim()}
            getSearchText={(s) => `${s.Description ?? ''} ${s.Long_Description ?? ''}`}
            placeholder={placeholder ?? t('selectors_size_placeholder')}
            disabled={disabled}
            readOnly={readOnly}
            leadingIcon={<RulerIcon />}
            className={className}
            emptyLabel={t('selectors_size_empty')}
        />
    );
};

export default SizeSelector;
